import paayService from '@/services/paay-three-ds';
import cardinalService from '@/services/cardinal-three-ds';
import cloverService from '@/services/clover-three-ds';

/**
 * Services are factory functions. Paay/Cardinal expose submitTdsTransaction (pre-payment token);
 * Clover exposes getBrowserInfo — its 3DS runs as a post-payment action loop in services/pay.js.
 */
const providerMap = {
  Paay: paayService,
  Cardinal: cardinalService,
  Clover: cloverService
};

const _getTdsProviderService = providerName => providerMap[providerName] ?? null;

const getTdsProvider = (providers) => {
  const gateway = Object.values(providers).find(provider => provider.threeDsConfig?.threeDsRequired);

  const { threeDsConfig, merchantUuid } = gateway || {};

  const result = {
    tdsProviderService: _getTdsProviderService(threeDsConfig?.threeDsProvider),
    merchantUuid,
    ...threeDsConfig
  };

  return result;
};

export default getTdsProvider;
